module.exports = __webpack_public_path__ + "static/media/analytics.1782edc1.svg";